import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  return (
    <div className="navBar">
      <div className="logo">
        <img src="/logo.png" alt="logo" />
      </div>

      <div className="menu-control">
        <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? '✕' : '☰'}
        </div>

        <div className={`links ${menuOpen ? 'active' : ''}`}>
          <Link to="/" onClick={toggleMenu}>Sobre Nós</Link>
          <Link to="/servicos" onClick={toggleMenu}>Serviços</Link>
          <Link to="/contato" onClick={toggleMenu}>Contato</Link>
          <a href="/blog">Blog</a>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
